// @todo Забирать с бекенда из методов доставки
export const NOVA_POSHTA_PRICE_LIMIT = 2999
export const NOVA_POSHTA_COURIER_PRICE_LIMIT = 3999
export const UKR_POSHTA_PRICE_LIMIT = 2999
export const COURIER_PRICE_LIMIT = 2999
export const NOVA_POSHTA_POSTOMAT_PRICE_LIMIT = 1499
